// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .bdt-card-box>.card {}

.bdt-card-box>.card>.card-body {
    padding: 5px !important;
} */

.BDT_Filter_Bus_bdt_card_box__ld8hu>.BDT_Filter_Bus_card__fNqHr {}

.BDT_Filter_Bus_bdt_card_box__ld8hu>.BDT_Filter_Bus_card__fNqHr>.BDT_Filter_Bus_card-body__uuFaA {
    padding: 5px !important;
}

/* .small-bdt {
    font-size: 80% !important;
} */

.BDT_Filter_Bus_small_bdt__WzfNd {
    font-size: 80% !important;
}

.BDT_Filter_Bus_filter_bus_icon_bdt__GS-Py .BDT_Filter_Bus_rca_btn__EzXGr .BDT_Filter_Bus_rca_btn_bus__mEB\\+e {
    background-color: #ffa650;
}

.BDT_Filter_Bus_filter_bus_icon_bdt__GS-Py .BDT_Filter_Bus_rca_btn__EzXGr .BDT_Filter_Bus_rca_btn_bus__mEB\\+e:hover {
    background-color: #fcb877 !important;
    border-color: #fcb877 !important;
}

/* .top-filter-bdt {
    width: 100%;
    background: #fff;
    height: 35px;
    border: solid 1px #a5a5a5;
    border-radius: 3px;
    font-size: 14px;
    color: #353535;
    text-indent: 10px;
    margin-bottom: 12px;
} */

.BDT_Filter_Bus_top_filter_bdt__BF1ak {
    width: 100%;
    background: #fff;
    height: 35px;
    border: solid 1px #a5a5a5;
    border-radius: 3px;
    font-size: 14px;
    color: #353535;
    text-indent: 10px;
    margin-bottom: 12px;
}




/* .bus_filtr_btn_bdt .btn_BDT:focus,
.btn_BDT:focus-visible,
.btn_BDT:focus-within,
.btn_BDT:hover,
.btn_BDT:visited,
.btn_BDT:active,
.btn_BDT:target {
    background-color: #83a4cf !important;
    border-color: #83a4cf !important;
} */

.BDT_Filter_Bus_btn_bus_bdt__8QM2M {
    background-color: #83A4CF !important;
}

.BDT_Filter_Bus_bus_filtr_btn_bdt__oed5p {
    position: relative;
    top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/BatteryDigitalTwin_Bus/BDT_Filter_Bus.module.css"],"names":[],"mappings":"AAAA;;;;GAIG;;AAEH,iEAAqB;;AAErB;IACI,uBAAuB;AAC3B;;AAEA;;GAEG;;AAEH;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;;;;;;;;;;GAUG;;AAEH;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,mBAAmB;AACvB;;;;;AAKA;;;;;;;;;GASG;;AAEH;IACI,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb","sourcesContent":["/* .bdt-card-box>.card {}\n\n.bdt-card-box>.card>.card-body {\n    padding: 5px !important;\n} */\n\n.bdt_card_box>.card {}\n\n.bdt_card_box>.card>.card-body {\n    padding: 5px !important;\n}\n\n/* .small-bdt {\n    font-size: 80% !important;\n} */\n\n.small_bdt {\n    font-size: 80% !important;\n}\n\n.filter_bus_icon_bdt .rca_btn .rca_btn_bus {\n    background-color: #ffa650;\n}\n\n.filter_bus_icon_bdt .rca_btn .rca_btn_bus:hover {\n    background-color: #fcb877 !important;\n    border-color: #fcb877 !important;\n}\n\n/* .top-filter-bdt {\n    width: 100%;\n    background: #fff;\n    height: 35px;\n    border: solid 1px #a5a5a5;\n    border-radius: 3px;\n    font-size: 14px;\n    color: #353535;\n    text-indent: 10px;\n    margin-bottom: 12px;\n} */\n\n.top_filter_bdt {\n    width: 100%;\n    background: #fff;\n    height: 35px;\n    border: solid 1px #a5a5a5;\n    border-radius: 3px;\n    font-size: 14px;\n    color: #353535;\n    text-indent: 10px;\n    margin-bottom: 12px;\n}\n\n\n\n\n/* .bus_filtr_btn_bdt .btn_BDT:focus,\n.btn_BDT:focus-visible,\n.btn_BDT:focus-within,\n.btn_BDT:hover,\n.btn_BDT:visited,\n.btn_BDT:active,\n.btn_BDT:target {\n    background-color: #83a4cf !important;\n    border-color: #83a4cf !important;\n} */\n\n.btn_bus_bdt {\n    background-color: #83A4CF !important;\n}\n\n.bus_filtr_btn_bdt {\n    position: relative;\n    top: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bdt_card_box": `BDT_Filter_Bus_bdt_card_box__ld8hu`,
	"card": `BDT_Filter_Bus_card__fNqHr`,
	"card-body": `BDT_Filter_Bus_card-body__uuFaA`,
	"small_bdt": `BDT_Filter_Bus_small_bdt__WzfNd`,
	"filter_bus_icon_bdt": `BDT_Filter_Bus_filter_bus_icon_bdt__GS-Py`,
	"rca_btn": `BDT_Filter_Bus_rca_btn__EzXGr`,
	"rca_btn_bus": `BDT_Filter_Bus_rca_btn_bus__mEB+e`,
	"top_filter_bdt": `BDT_Filter_Bus_top_filter_bdt__BF1ak`,
	"btn_bus_bdt": `BDT_Filter_Bus_btn_bus_bdt__8QM2M`,
	"bus_filtr_btn_bdt": `BDT_Filter_Bus_bus_filtr_btn_bdt__oed5p`
};
export default ___CSS_LOADER_EXPORT___;
